import React, { useState, useEffect } from 'react';
import api from './api';

const JobWorkerMaster = () => {
    const [workers, setWorkers] = useState([]);
    const [form, setForm] = useState({ name: "", department: "Galaxy", city: "", contactNumber: "" });

    useEffect(() => { loadWorkers(); }, []);

    const loadWorkers = async () => {
        const res = await api.get('/job-workers');
        setWorkers(res.data);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await api.post('/job-workers/add', form);
            setForm({ name: "", department: "Galaxy", city: "", contactNumber: "" });
            loadWorkers();
            alert("✅ Job Worker Added!");
        } catch (err) { alert("Error adding worker"); }
    };

    const handleDelete = async (id) => {
        if(!window.confirm("Delete this worker?")) return;
        await api.delete(`/job-workers/${id}`);
        loadWorkers();
    };

    return (
        <div className="container mt-4">
            <h3 className="text-primary fw-bold mb-4">👷 Job Worker Master (Contractors)</h3>
            
            <div className="row">
                {/* FORM */}
                <div className="col-md-4">
                    <div className="card shadow-sm">
                        <div className="card-header bg-dark text-white">Add New Worker</div>
                        <div className="card-body">
                            <form onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <label className="form-label">Company / Name</label>
                                    <input className="form-control" value={form.name} onChange={e=>setForm({...form, name: e.target.value})} required placeholder="e.g. Sahajanand Tech" />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Department</label>
                                    <select className="form-select" value={form.department} onChange={e=>setForm({...form, department: e.target.value})}>
                                        <option value="Galaxy">Galaxy</option>
                                        <option value="Sawing">Sawing</option>
                                        <option value="Polishing">Polishing</option>
                                    </select>
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">City</label>
                                    <input className="form-control" value={form.city} onChange={e=>setForm({...form, city: e.target.value})} />
                                </div>
                                <button className="btn btn-success w-100">Save Worker</button>
                            </form>
                        </div>
                    </div>
                </div>

                {/* LIST */}
                <div className="col-md-8">
                    <div className="card shadow-sm">
                        <div className="card-body p-0">
                            <table className="table table-hover mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th>Name</th>
                                        <th>Department</th>
                                        <th>City</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {workers.map(w => (
                                        <tr key={w._id}>
                                            <td className="fw-bold">{w.name}</td>
                                            <td><span className="badge bg-secondary">{w.department}</span></td>
                                            <td>{w.city}</td>
                                            <td><button onClick={()=>handleDelete(w._id)} className="btn btn-sm btn-outline-danger">🗑️</button></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default JobWorkerMaster;